import { useChartLayoutOrientation } from '../../../core/components/chart-layout/hooks/useChartLayoutOrientation.js';
import { getLegendOrientation } from '../../../core/components/chart-layout/utils/orientation.js';
import { RangeLegend } from '../../../core/components/legend/range/RangeLegend.js';
import { computeRangeLegendFormatter } from '../../../core/utils/compute-range-legend-formatter.js';
import { useFormatter } from '../../context/FormatterContext.js';
import { useTreeMapInternalData } from '../../context/TreeMapInternalDataContext.js';
import { useColorMap } from '../../store/selectors.js';
import type { RangeLegendColorMap } from '../../types/internal.js';

export const TreeMapRangeLegend = () => {
  const legendColorMap = useColorMap() as RangeLegendColorMap;
  const { orientation: layoutOrientation } = useChartLayoutOrientation();
  const legendOrientation = getLegendOrientation(layoutOrientation);

  const { unit } = useTreeMapInternalData();
  const formatter = useFormatter();

  const computedFormatter = computeRangeLegendFormatter(formatter, unit);

  const legendItemKeys = [...legendColorMap.keys()];
  const items = legendItemKeys.map((key) => ({
    from: key.from,
    to: key.to,
    color: legendColorMap.get(key)?.color?.Default,
  }));

  return (
    <RangeLegend
      items={items}
      orientation={legendOrientation}
      formatter={computedFormatter}
    />
  );
};
